import React from 'react';
import { NavLink } from 'react-router-dom';
import brandLogo from '../../../assets/brandLogo.png';

import './Footer.scss';

const Footer = () => {
  const socialLinks = [
    {
      name: 'fab fa-facebook-f',
      href: 'https://www.facebook.com/playsportusa1/',
      label: 'Facebook',
    },
    {
      name: 'fab fa-instagram',
      href: 'https://www.instagram.com/playsportusa1/',
      label: 'Instagram',
    },
    {
      name: 'fab fa-youtube',
      href: 'https://www.youtube.com/channel/UCChDfRK8jPXg0MBuyoBa10g',
      label: 'YouTube',
    },
  ];

  const quickLinks = [
    { name: 'Available Players', link: '/available-players' },
    { name: 'About Us', link: '/about-us' },
    { name: 'FAQ', link: '/faq' },
    { name: 'Sample Profile', link: '/sample-profile' },
    { name: 'College Summer Trips', link: '/college-summer-trips' },
  ];

  const renderSocialLinks = () =>
    socialLinks.map(({ name, href, label }) => (
      <a
        className="footer__social-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={name}
        aria-label={label}
      >
        <i className={name} />
      </a>
    ));

  const renderQuickLinks = () =>
    quickLinks.map(({ name, link }) => (
      <li key={name}>
        <NavLink to={link} className="footer__link">
          {name}
        </NavLink>
      </li>
    ));

  return (
    <footer className="Footer">
      <div className="footer__main">
        <div className="footer__container">
          {/* Brand Section */}
          <div className="footer__section footer__section--brand">
            <img src={brandLogo} alt="PlaySportUSA Logo" className="footer__logo" />
            <p className="footer__description">
              Connecting talented athletes with opportunities to play sports at American colleges and universities. 
              Your journey to a sports scholarship starts here.
            </p>
            <div className="footer__social-icons">
              {renderSocialLinks()}
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer__section">
            <h4 className="footer__title">Quick Links</h4>
            <ul className="footer__links">
              {renderQuickLinks()}
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer__section">
            <h4 className="footer__title">Contact Us</h4>
            <ul className="footer__contact">
              <li>
                <i className="fas fa-envelope" />
                <a href="mailto:contact@playsportusa.com">contact@playsportusa.com</a>
              </li>
              <li>
                <i className="fas fa-phone" />
                <span>(+48) 794 024 963</span>
              </li>
            </ul>
          </div>

          {/* Sports Section */}
          <div className="footer__section">
            <h4 className="footer__title">Sports We Cover</h4>
            <ul className="footer__sports">
              <li><i className="fas fa-volleyball-ball" /> Volleyball</li>
              <li><i className="fas fa-volleyball-ball" /> Beach Volleyball</li>
              <li><i className="fas fa-futbol" /> Soccer</li>
              <li><i className="fas fa-swimmer" /> Swimming</li>
              <li><i className="fas fa-table-tennis" /> Tennis</li>
              <li><i className="fas fa-basketball-ball" /> Basketball</li>
              <li><i className="fas fa-running" /> Track & Field</li>
              <li><i className="fas fa-hockey-puck" /> Ice Hockey</li>
              <li><i className="fas fa-swimmer" /> Water Polo</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <div className="footer__bottom-container">
          <span className="footer__copyright">
            © {new Date().getFullYear()} PlaySportUSA. All Rights Reserved.
          </span>
          <span className="footer__credits">
            Designed & Developed by devQuest
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
